<script>
  /** @type {string} */
    export let name;
     /** @type {string} */
    export let img;
     /** @type {string} */
    export let avif;
     /** @type {string} */
    export let webp;
     /** @type {string} */
    export let party;


  $: isThereAHeadshot = (img)=> {
    if ((img.includes('person_male.png'))|| (img.includes('person_female.png'))) {
      return false;
    } else {
      return true;
    }
  }

  $: HeadshotExists = isThereAHeadshot(img);
  $: headshotAlt = `Headshot of ${name}`;
  $: noHeadshotAlt = `No photo available for ${name}, generic image`;


</script>

  <picture>
    <source
      type="image/avif"
      srcset={avif}
    />
    <source
      type="image/webp"
      srcset={webp}
    />
    <img 
      src={img} 
      class="{party ? party : ''}"
      alt="{HeadshotExists ? headshotAlt : noHeadshotAlt}"
      width="300" 
      height="300"
    />
  </picture>